import React from "react";
import { Col, Row, Button, InputGroup } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import profile from "../../assets/profile.png";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import {
  AddressCheck,
  EmailCheck,
  FirstNameCheck,
  LastNameCheck,
  MobileNumberCheck,
  SocialMediaCheck,
  ZipCodeCheck,
} from "../../ConditionChecks/ConditionChecks";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import {
  GeneralInfo,
  GeneralInfoAPI,
  UserProfile,
} from "../../Utils/Api/UserProfile";
import { useEffect } from "react";
import { userId } from "../../Utils/LocalStorage";
import Loader from "../../Components/Loader/Loader";
import { toast } from "react-toastify";
import { MdDelete, MdModeEditOutline } from "react-icons/md";
import { MdEdit } from "react-icons/md";
import { GetCity, GetCountry, GetState } from "../../Utils/Api/SignUP";
import AutoCompleteInput from "../../Components/AutoCompleteInput/AutoCompleteInput";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import DeletePopUp from "../../Components/DeletePopUp/DeletePopUp";

const MyProfileGeneralInfo = (props) => {
  // Boolean values for dynamic representation for edit first name, last name and buttons(save,cancel)
  const [UserData, setUserData] = useState({});
  const [mobileNumber, setMobileNumber] = useState("");

  const [editFlag, setEditFlag] = useState({
    editfirstname: false,
    editLastName: false,
    editEmailAddress: false,
    editContactNumber: false,
    editAddress1: false,
    editAddress2: false,
    editCountry: false,
    editState: false,
    editCity: false,
    editZipcode: false,
    editFacebookUrl: false,
    editTwitterURL: false,
    editInstagramURL: false,
    editLinkedInURL: false,
  });

  const [err_Display, setErr_Display] = useState({
    errFirstName: "",
    errLastName: "",
    errEmailAddress: "",
    errContactNumber: "",
    errAddress1: "",
    errAddress2: "",
    errCountry: "",
    errState: "",
    errCity: "",
    errZipcode: "",
    errFacebookUrl: "",
    errTwitterURL: "",
    errInstagramURL: "",
    errLinkedInURL: "",
  });

  const [userInput, setUserInput] = useState({
    editFirstName: "",
    editLastName: "",
    editEmailAddress: "",
    editContactNumber: "",
    editAddress1: "",
    editAddress2: "",
    editCountry: "",
    editState: "",
    editCity: "",
    editZipcode: "",
    editFacebookUrl: "",
    editTwitterURL: "",
    editInstagramURL: "",
    editLinkedInURL: "",
  });

  const [countryList, setCountryList] = useState([
    { country_id: "", state_name: "" },
  ]);
  const [stateList, setStateList] = useState([
    {
      mms_city_id: "",
      city_name: "",
    },
  ]);
  const [cityList, setCityList] = useState([]);
  const [editBtnflag, setEditBtnFlag] = useState(false);
  const [loading, setLoading] = useState(false);

  const [deletemodalShow, setDeleteModalShow] = useState(false);

  const CancelHandler = () => {
    setEditBtnFlag(false);
    setEditFlag(() => {
      return {
        editfirstname: false,
        editLastName: false,
        editEmailAddress: false,
        editContactNumber: false,
        editAddress1: false,
        editAddress2: false,
        editCountry: false,
        editState: false,
        editCity: false,
        editZipcode: false,
        editFacebookUrl: false,
        editTwitterURL: false,
        editInstagramURL: false,
        editLinkedInURL: false,
      };
    });
    window.scrollTo(0, 0);
  };

  const EditHandler = () => {
    setEditBtnFlag(true);
    // window.scrollTo({
    //   top: document.body.scrollHeight,
    //   left: 0,
    //   behavior: "smooth",
    // });
  };

  const onFirstName = (event) => {
    let value = event.target.value;
    setUserInput((prevState) => {
      return { ...prevState, editFirstName: value };
    });
    setEditFlag((prevState) => {
      return { ...prevState, editfirstname: true };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errFirstName: "" };
    });
  };

  const onLastName = (event) => {
    setUserInput((prevState) => {
      return { ...prevState, editLastName: event.target.value };
    });
    setEditFlag((prevState) => {
      return { ...prevState, editLastName: true };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errLastName: "" };
    });
  };

  // const onEmailAddress = (event) => {
  //   setUserInput((prevState) => {
  //     return { ...prevState, editEmailAddress: event.target.value };
  //   });
  //   setEditFlag((prevState) => {
  //     return { ...prevState, editEmailAddress: true };
  //   });
  //   setErr_Display((prevState) => {
  //     return { ...prevState, errEmailAddress: "" };
  //   });
  // };

  // const onContactNumber = (event) => {
  //   setUserInput((prevState) => {
  //     return { ...prevState, editContactNumber: event.target.value };
  //   });
  //   setEditFlag((prevState) => {
  //     return { ...prevState, editContactNumber: true };
  //   });
  //   setErr_Display((prevState) => {
  //     return { ...prevState, errContactNumber: "" };
  //   });
  // };

  const onAddress1 = (event) => {
    setUserInput((prevState) => {
      return { ...prevState, editAddress1: event.target.value };
    });
    setEditFlag((prevState) => {
      return { ...prevState, editAddress1: true };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errAddress1: "" };
    });
  };

  const onAddress2 = (event) => {
    setUserInput((prevState) => {
      return { ...prevState, editAddress2: event.target.value };
    });
    setEditFlag((prevState) => {
      return { ...prevState, editAddress2: true };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errAddress2: "" };
    });
  };

  const onCountry = (event) => {
    setUserInput((prevState) => {
      return { ...prevState, editCountry: event.target.value };
    });
    setEditFlag((prevState) => {
      return { ...prevState, editCountry: true };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errCountry: "" };
    });
  };

  const onState = (event) => {
    setUserInput((prevState) => {
      return { ...prevState, editState: event.target.value };
    });
    setEditFlag((prevState) => {
      return { ...prevState, editState: true };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errState: "" };
    });
  };

  const onCity = (event, flag) => {
    setUserInput((prevState) => {
      return { ...prevState, editCity: event.target.value };
    });
    setEditFlag((prevState) => {
      return { ...prevState, editCity: flag };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errCity: "" };
    });
  };

  const onZipcode = (event) => {
    setUserInput((prevState) => {
      return { ...prevState, editZipcode: event.target.value };
    });
    setEditFlag((prevState) => {
      return { ...prevState, editZipcode: true };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errZipcode: "" };
    });
  };

  const onFacebookUrl = (event) => {
    setEditFlag((prevState) => {
      return { ...prevState, editFacebookUrl: true };
    });
    setUserInput((prevState) => {
      return { ...prevState, editFacebookUrl: event.target.value };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errFacebookUrl: "" };
    });
  };

  const onTwitterURL = (event) => {
    setEditFlag((prevState) => {
      return { ...prevState, editTwitterURL: true };
    });
    setUserInput((prevState) => {
      return { ...prevState, editTwitterURL: event.target.value };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errTwitterURL: "" };
    });
  };

  const onInstagramURL = (event) => {
    setEditFlag((prevState) => {
      return { ...prevState, editInstagramURL: true };
    });
    setUserInput((prevState) => {
      return { ...prevState, editInstagramURL: event.target.value };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errInstagramURL: "" };
    });
  };

  const onLinkedInURL = (event) => {
    setEditFlag((prevState) => {
      return { ...prevState, editLinkedInURL: true };
    });
    setUserInput((prevState) => {
      return { ...prevState, editLinkedInURL: event.target.value };
    });
    setErr_Display((prevState) => {
      return { ...prevState, errLinkedInURL: "" };
    });
  };

  const navigate = useNavigate();

  const Bu_Id = userId();

  const SaveHandler = (e) => {
    e.preventDefault();
    const FirstNameValidation = FirstNameCheck(
      editFlag.editfirstname === true
        ? userInput.editFirstName
        : UserData.first_name
    );
    const LastNameValidation = LastNameCheck(
      editFlag.editLastName === true
        ? userInput.editLastName
        : UserData.last_name
    );

    // const EmailValidation = EmailCheck(
    //   editFlag.editEmailAddress === true
    //     ? userInput.editEmailAddress
    //     : UserData.email
    // );

    // const ContactNumberValidation = MobileNumberCheck(
    //   editFlag.editContactNumber === true
    //     ? userInput.editContactNumber
    //     : UserData.contact_number
    // );

    const Address1Validation = AddressCheck(
      editFlag.editAddress1 === true
        ? userInput.editAddress1
        : UserData.address1
    );

    // const Address2Validation = AddressCheck(
    //   editFlag.editAddress1 === true
    //     ? userInput.editAddress2
    //     : UserData.address2
    // );

    const ZipCodeValidation = ZipCodeCheck(
      editFlag.editZipcode === true ? userInput.editZipcode : UserData.zipcode
    );

    const facebookValidation = SocialMediaCheck(
      editFlag.editFacebookUrl === true
        ? userInput.editFacebookUrl
        : UserData.facebook_url
    );
    const TwitterValidation = SocialMediaCheck(
      editFlag.editTwitterURL === true
        ? userInput.editTwitterURL
        : UserData.twitter_url
    );
    const InstaValidation = SocialMediaCheck(
      editFlag.editInstagramURL === true
        ? userInput.editInstagramURL
        : UserData.instagram_url
    );
    const LinkedInValidation = SocialMediaCheck(
      editFlag.editLinkedInURL === true
        ? userInput.editLinkedInURL
        : UserData.linkedin_url
    );

    let GeneralInfoValidation = true;

    if (FirstNameValidation.input === "empty") {
      setErr_Display((prevState) => {
        return { ...prevState, errFirstName: FirstNameValidation.err_display };
      });
      GeneralInfoValidation = false;
    }

    if (LastNameValidation.input === "empty") {
      setErr_Display((prevState) => {
        return { ...prevState, errLastName: LastNameValidation.err_display };
      });
      GeneralInfoValidation = false;
    }

    // if (EmailValidation.input === "empty") {
    //   setErr_Display((prevState) => {
    //     return { ...prevState, errEmailAddress: EmailValidation.err_display };
    //   });
    // } else if (EmailValidation.input === "invalid") {
    //   setErr_Display((prevState) => {
    //     return { ...prevState, errEmailAddress: EmailValidation.err_display };
    //   });
    // }

    // if (ContactNumberValidation.input === "empty") {
    //   setErr_Display((prevState) => {
    //     return {
    //       ...prevState,
    //       errContactNumber: ContactNumberValidation.err_display,
    //     };
    //   });
    // } else if (ContactNumberValidation.input === "invalid") {
    //   setErr_Display((prevState) => {
    //     return {
    //       ...prevState,
    //       errContactNumber: ContactNumberValidation.err_display,
    //     };
    //   });
    // }

    if (Address1Validation.input === "empty") {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errAddress1: Address1Validation.err_display,
        };
      });
      GeneralInfoValidation = false;
    } else if (Address1Validation.input === "maxCharacters") {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errAddress1: Address1Validation.err_display,
        };
      });
      GeneralInfoValidation = false;
    }

    // if (Address2Validation.input === "empty") {
    //   setErr_Display((prevState) => {
    //     return {
    //       ...prevState,
    //       errAddress2: Address2Validation.err_display,
    //     };
    //   });
    // } else if (Address2Validation.input === "maxCharacters") {
    //   setErr_Display((prevState) => {
    //     return {
    //       ...prevState,
    //       errAddress2: Address2Validation.err_display,
    //     };
    //   });
    // }

    if (editFlag.editCountry === true && !userInput.editCountry) {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errCountry: "Please select the Country!",
        };
      });
      GeneralInfoValidation = false;
    }

    if (editFlag.editState === true && !userInput.editState) {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errState: "Please select the State!",
        };
      });
      GeneralInfoValidation = false;
    }
    if (editFlag.editCity === true && !userInput.editCity) {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errCity: "Please select the City!",
        };
      });
      GeneralInfoValidation = false;
    }

    if (ZipCodeValidation.input === "empty") {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errZipcode: ZipCodeValidation.err_display,
        };
      });
      GeneralInfoValidation = false;
    } else if (ZipCodeValidation.input === "invalid") {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errZipcode: ZipCodeValidation.err_display,
        };
      });
      GeneralInfoValidation = false;
    } else if (ZipCodeValidation.input === "Characters") {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errZipcode: ZipCodeValidation.err_display,
        };
      });
      GeneralInfoValidation = false;
    }

    if (facebookValidation.input === "empty") {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errFacebookUrl:
            editFlag.editFacebookUrl === true
              ? facebookValidation.err_display
              : "",
        };
      });
      // GeneralInfoValidation = false;
    } else if (facebookValidation.input === "invalid") {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errFacebookUrl:
            editFlag.editFacebookUrl === true
              ? facebookValidation.err_display
              : "",
        };
      });
      // GeneralInfoValidation = false;
    }

    if (TwitterValidation.input === "empty") {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errTwitterURL:
            editFlag.editTwitterURL === true
              ? TwitterValidation.err_display
              : "",
        };
      });
      // GeneralInfoValidation = false;
    } else if (TwitterValidation.input === "invalid") {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errTwitterURL:
            editFlag.editTwitterURL === true
              ? TwitterValidation.err_display
              : "",
        };
      });
      // GeneralInfoValidation = false;
    }

    if (InstaValidation.input === "empty") {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errInstagramURL:
            editFlag.editInstagramURL === true
              ? InstaValidation.err_display
              : "",
        };
      });
      // GeneralInfoValidation = false;
    } else if (InstaValidation.input === "invalid") {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errInstagramURL:
            editFlag.editInstagramURL === true
              ? InstaValidation.err_display
              : "",
        };
      });
      // GeneralInfoValidation = false;
    }

    if (LinkedInValidation.input === "empty") {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errLinkedInURL:
            editFlag.editLinkedInURL === true
              ? LinkedInValidation.err_display
              : "",
        };
      });
      // GeneralInfoValidation = false;
    } else if (LinkedInValidation.input === "invalid") {
      setErr_Display((prevState) => {
        return {
          ...prevState,
          errLinkedInURL:
            editFlag.editLinkedInURL === true
              ? LinkedInValidation.err_display
              : "",
        };
      });
      // GeneralInfoValidation = false;
    }

    if (editBtnflag && GeneralInfoValidation === true) {
      let UpdateCredentials = {
        first_name:
          editFlag.editfirstname === true
            ? userInput.editFirstName
            : UserData.first_name,
        last_name:
          editFlag.editLastName === true
            ? userInput.editLastName
            : UserData.last_name,
        // bu_email:
        //   editFlag.editEmailAddress === true
        //     ? userInput.editEmailAddress
        //     : UserData.email,

        // bu_contact_no:
        //   editFlag.editContactNumber === true
        //     ? userInput.editContactNumber
        //     : UserData.contact_number,

        address1:
          editFlag.editAddress1 === true
            ? userInput.editAddress1
            : UserData.address1,

        address2:
          editFlag.editAddress2 === true
            ? userInput.editAddress2
            : UserData.address2,

        state: parseInt(
          editFlag.editState === true
            ? userInput.editState
            : UserData.bu_state_id
        ),
        // city: parseInt(userInput.editCity),
        zipcode: parseInt(userInput.editZipcode),
        country: parseInt(
          editFlag.editCountry === true
            ? userInput.editCountry
            : UserData.bu_country_id
        ),
        city:
          editFlag.editCity === true ? userInput.editCity : UserData.bu_city_id,
        zipcode: parseInt(UserData.zipcode),
        facebook_url:
          editFlag.editFacebookUrl === true
            ? userInput.editFacebookUrl
            : UserData.facebook_url,
        twitter_url:
          editFlag.editTwitterURL === true
            ? userInput.editTwitterURL
            : UserData.twitter_url,
        instagram_url:
          editFlag.editInstagramURL === true
            ? userInput.editInstagramURL
            : UserData.instagram_url,
        linkedin_url:
          editFlag.editLinkedInURL === true
            ? userInput.editLinkedInURL
            : UserData.linkedin_url,
        bu_id: parseInt(Bu_Id),
        api_method: "post",
      };

      UpdateUserCredentials(UpdateCredentials);

      setErr_Display(() => {
        return {
          errFirstName: "",
          errLastName: "",
          errEmailAddress: "",
          errContactNumber: "",
          errAddress1: "",
          errAddress2: "",
          errCountry: "",
          errState: "",
          errCity: "",
          errZipcode: "",
          errFacebookUrl: "",
          errTwitterURL: "",
          errInstagramURL: "",
          errLinkedInURL: "",
        };
      });
    }
  };

  const GetCountryAPIHandler = async () => {
    const getCountry = await GetCountry();

    setCountryList(getCountry.data);
  };

  const GetStateApiHandler = async () => {
    const data = {
      country_id: parseInt(
        editFlag.editCountry === true
          ? userInput.editCountry
          : UserData.bu_country_id
      ),
    };
    const getState = await GetState(data, () => {
      navigate("/");
    });

    // if (userInput.editCountry.length > 0) {
    setStateList(getState.data);
    // } else {
    //   setStateList([]);
    // }
  };

  const GetCityApiHandler = async () => {
    const data = {
      state_id: parseInt(
        editFlag.editState === true ? userInput.editState : UserData.bu_state_id
      ),
    };
    const getCity = await GetCity(data, () => {
      navigate("/");
    });
    setCityList(getCity.data);
  };

  const UserCredentials = async () => {
    const data = { bu_id: parseInt(Bu_Id), api_method: "get" };
    setLoading(true);
    const usercredentials = await GeneralInfoAPI(data, () => {
      navigate("/");
    });
    if (usercredentials.status === 429) {
      setLoading(true);
      toast.error(usercredentials.message, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
    setLoading(false);
    setUserData(usercredentials?.data[0]);
    let digits = usercredentials?.data[0]?.contact_number?.replace(/\D/g, "");
    digits = digits?.substring(0, 10);
    let formatted = digits;
    if (digits.length > 3) {
      formatted = digits.substring(0, 3) + "-" + digits.substring(3);
    }
    if (digits.length > 6) {
      formatted = formatted.substring(0, 7) + "-" + formatted.substring(7);
    }
    setMobileNumber(formatted);
  };

  const UpdateUserCredentials = async (data) => {
    setLoading(true);
    const usercredentials = await GeneralInfoAPI(data, () => {
      navigate("/");
    });
    setLoading(false);
    if (usercredentials.success === true) {
      toast.success("Updated profile successfully!", {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setEditBtnFlag(false);
      UserCredentials();
      window.scrollTo(0, 0);
    }
    if (usercredentials.status === 429) {
      setLoading(true);
      toast.error(usercredentials.message, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else if (usercredentials.success === false) {
      toast.error(usercredentials.message, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  useEffect(() => {
    GetStateApiHandler();
  }, [userInput.editCountry, editBtnflag]);

  useEffect(() => {
    GetCityApiHandler();
  }, [userInput.editState, editBtnflag]);

  useEffect(() => {
    UserCredentials();
    GetCountryAPIHandler();
  }, []);

  return (
    <>
      {loading ? <Loader /> : ""}
      <Row>
        <p>
          To make any changes, click on edit button, make the changes and click
          on save button.
        </p>
        <Col md="1" lg="2"></Col>
        <Col md="10" lg="8">
          <p className="page-maintitle pr-2">
            <div className="text-right two-btns mr-5">
              {editBtnflag === true ? (
                <Button
                  className="green-btn btn-margin"
                  onClick={(e) => SaveHandler(e)}
                >
                  Save
                </Button>
              ) : (
                <>
                  <Button
                    className="green-btn btn-margin"
                    onClick={EditHandler}
                  >
                    <MdEdit className="mb-1" /> Edit
                  </Button>
                </>
              )}
            </div>
          </p>
          <Form className="formmain mx-5 mt-4 signin-row profile-form pb-4">
            <Row>
              <Col md="6" className="">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    First Name <span className="star-required">*</span>
                  </Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Control
                      type="text"
                      value={
                        editFlag?.editfirstname === true
                          ? userInput?.editFirstName
                          : UserData?.first_name
                      }
                      placeholder="Enter First Name"
                      className="custom-formcontrol"
                      onChange={onFirstName}
                      disabled={editBtnflag === true ? false : true}
                      maxLength={50}
                      autoComplete="off"
                    />
                  </InputGroup>
                  <ErrorLabel ErrorDisplay={err_Display.errFirstName} />
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Last Name <span className="star-required">*</span>
                  </Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Control
                      type="text"
                      value={
                        editFlag?.editLastName === true
                          ? userInput?.editLastName
                          : UserData?.last_name
                      }
                      placeholder="Enter Last name"
                      maxLength={50}
                      disabled={editBtnflag === true ? false : true}
                      className="custom-formcontrol"
                      onChange={onLastName}
                      autoComplete="off"
                    />
                  </InputGroup>
                  <ErrorLabel ErrorDisplay={err_Display.errLastName} />
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Label className="form-label-custom edit-sec">
                  Contact Email Address <span className="star-required">*</span>
                </Form.Label>
                <InputGroup className="mb-0 edit-border">
                  <Form.Control
                    value={
                      // editFlag.editEmailAddress === true
                      //   ? userInput.editEmailAddress :
                      UserData?.email
                    }
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    placeholder="enter Email Address"
                    // onChange={onEmailAddress}
                    disabled={true}
                    maxLength={70}
                    autoComplete="off"
                  />
                </InputGroup>
                <ErrorLabel ErrorDisplay={err_Display.errEmailAddress} />
              </Col>
              <Col md="6" className="">
                <Form.Label className="form-label-custom edit-sec">
                  Mobile Number <span className="star-required">*</span>
                </Form.Label>
                <InputGroup
                  className="mb-0 edit-border general_Mobile"
                  style={{ display: "flex", flexWrap: "unset" }}
                >
                  <Form.Control
                    value="+1"
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    disabled={true}
                  />
                  <Form.Control
                    value={
                      // editFlag.editContactNumber === true
                      //   ? userInput.editContactNumber :
                      mobileNumber
                    }
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    placeholder="Enter Contact Number"
                    // onChange={onContactNumber}
                    disabled={true}
                    maxLength={15}
                    autoComplete="off"
                  />
                </InputGroup>
                <ErrorLabel ErrorDisplay={err_Display.errContactNumber} />
              </Col>
              <Col md="6" className="">
                <Form.Label className="form-label-custom edit-sec">
                  Business Address 1 <span className="star-required">*</span>
                </Form.Label>
                <Form.Group
                  className="mb-0"
                  controlId="exampleForm.ControlTextarea1"
                  placeholder="Enter Business Address"
                >
                  <Form.Control
                    autoComplete="off"
                    as="textarea"
                    rows={3}
                    maxLength={100}
                    onChange={onAddress1}
                    value={
                      editFlag?.editAddress1 === true
                        ? userInput?.editAddress1
                        : UserData?.address1
                    }
                    disabled={editBtnflag === true ? false : true}
                  />
                </Form.Group>
                <ErrorLabel ErrorDisplay={err_Display.errAddress1} />
              </Col>
              <Col md="6" className="">
                <Form.Label className="form-label-custom edit-sec">
                  Business Address 2
                </Form.Label>
                <Form.Group
                  className="mb-0"
                  controlId="exampleForm.ControlTextarea1"
                  placeholder="Enter Business Address"
                >
                  <Form.Control
                    as="textarea"
                    rows={3}
                    autoComplete="off"
                    maxLength={100}
                    onChange={onAddress2}
                    value={
                      editFlag?.editAddress2 === true
                        ? userInput?.editAddress2
                        : UserData?.address2
                    }
                    disabled={editBtnflag === true ? false : true}
                  />
                </Form.Group>
                <ErrorLabel ErrorDisplay={err_Display.errAddress2} />
              </Col>

              {editBtnflag === true ? (
                <>
                  <Col md="6" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        Country <span className="star-required">*</span>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        onChange={onCountry}
                        value={
                          editFlag?.editCountry === true
                            ? userInput?.editCountry
                            : UserData?.bu_country_id
                        }
                      >
                        <option>Select Country</option>
                        {countryList?.length != 0 ? (
                          countryList?.map((data) => {
                            return (
                              <option
                                value={data.country_id}
                                key={data.country_id}
                              >
                                {data.country_name}
                              </option>
                            );
                          })
                        ) : (
                          <></>
                        )}
                      </Form.Select>
                    </Form.Group>
                    <ErrorLabel ErrorDisplay={err_Display.errCountry} />
                  </Col>
                  <Col md="6" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        State <span className="star-required">*</span>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        onChange={onState}
                        value={
                          editFlag.editState === true
                            ? userInput.editState
                            : UserData.bu_state_id
                        }
                      >
                        {stateList?.length > 0 ? (
                          stateList.map((data) => {
                            return (
                              <option value={data.state_id} key={data.state_id}>
                                {data.state_name}
                              </option>
                            );
                          })
                        ) : (
                          <></>
                        )}
                      </Form.Select>
                    </Form.Group>
                    <ErrorLabel ErrorDisplay={err_Display.errState} />
                  </Col>

                  <AutoCompleteInput
                    CityList={cityList}
                    EditFlag={editFlag.editCity}
                    EditCity={userInput.editCity}
                    ApiCity={UserData.bu_city_id}
                    onCityFuc={onCity}
                    ErrDisplay={err_Display.errCity}
                    Md={"6"}
                    NameFlag={"myBrowser"}
                  />

                  {/* <Col md="6" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        City <span className="star-required">*</span>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        onChange={onCity}
                        value={
                          editFlag.editCity === true
                            ? userInput.editCity
                            : UserData.bu_city_id
                        }
                      >
                        {cityList?.length > 0 ? (
                          cityList.map((data) => {
                            return (
                              <option value={data.mms_city_id}>
                                {data.city_name}
                              </option>
                            );
                          })
                        ) : (
                          <></>
                        )}
                      </Form.Select>
                    </Form.Group>
                    <ErrorLabel ErrorDisplay={err_Display.errCity} />
                  </Col> */}
                </>
              ) : (
                <>
                  <Col md="6" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        Country <span className="star-required">*</span>
                      </Form.Label>
                      <InputGroup className="edit-border">
                        <Form.Control
                          type="text"
                          value={UserData.country}
                          placeholder="Enter country"
                          className="custom-formcontrol"
                          disabled={true}
                          autoComplete="off"
                          // onChange={onZipcode}
                        />
                      </InputGroup>
                      <ErrorLabel ErrorDisplay={err_Display.errZipcode} />
                    </Form.Group>
                  </Col>
                  <Col md="6" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        State <span className="star-required">*</span>
                      </Form.Label>
                      <InputGroup className="edit-border">
                        <Form.Control
                          type="text"
                          value={UserData.state}
                          placeholder="Enter zipcode"
                          className="custom-formcontrol"
                          disabled={true}
                          // onChange={onZipcode}
                          autoComplete="off"
                        />
                      </InputGroup>
                      <ErrorLabel ErrorDisplay={err_Display.errZipcode} />
                    </Form.Group>
                  </Col>
                  <Col md="6" className="">
                    <Form.Group className="mb-0" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        City <span className="star-required">*</span>
                      </Form.Label>
                      <InputGroup className="edit-border">
                        <Form.Control
                          type="text"
                          value={UserData.bu_city_id}
                          placeholder="Enter zipcode"
                          className="custom-formcontrol"
                          disabled={true}
                          // onChange={onZipcode}
                          autoComplete="off"
                        />
                      </InputGroup>
                      <ErrorLabel ErrorDisplay={err_Display.errZipcode} />
                    </Form.Group>
                  </Col>
                </>
              )}

              <Col md="6" className="">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Zipcode <span className="star-required">*</span>
                  </Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Control
                      type="text"
                      value={
                        editFlag.editZipcode === true
                          ? userInput.editZipcode
                          : UserData.zipcode
                      }
                      maxLength={11}
                      placeholder="Enter zipcode"
                      className="custom-formcontrol"
                      disabled={editBtnflag === true ? false : true}
                      onChange={onZipcode}
                      autoComplete="off"
                    />
                  </InputGroup>
                  <ErrorLabel ErrorDisplay={err_Display.errZipcode} />
                </Form.Group>
              </Col>
              <hr className="primary-hr" />
              <p className="soc-text mb-2">Social Media</p>
              <Col md="6" className="">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Facebook URL
                  </Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Control
                      type="text"
                      value={
                        editFlag.editFacebookUrl === true
                          ? userInput.editFacebookUrl
                          : UserData.facebook_url
                      }
                      placeholder="Paste your facebook URL here"
                      className="custom-formcontrol"
                      onChange={onFacebookUrl}
                      disabled={editBtnflag === true ? false : true}
                      autoComplete="off"
                    />
                  </InputGroup>
                  <ErrorLabel ErrorDisplay={err_Display.errFacebookUrl} />
                  {/* // */}
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">X URL</Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Control
                      type="text"
                      value={
                        editFlag.editTwitterURL === true
                          ? userInput.editTwitterURL
                          : UserData.twitter_url
                      }
                      placeholder="Paste your X URL here"
                      className="custom-formcontrol"
                      onChange={onTwitterURL}
                      disabled={editBtnflag === true ? false : true}
                      autoComplete="off"
                    />
                  </InputGroup>
                  <ErrorLabel ErrorDisplay={err_Display.errTwitterURL} />
                  {/* // */}
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Instagram URL
                  </Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Control
                      type="text"
                      value={
                        editFlag.editInstagramURL === true
                          ? userInput.editInstagramURL
                          : UserData.instagram_url
                      }
                      placeholder="Paste your Instagram URL here"
                      className="custom-formcontrol"
                      onChange={onInstagramURL}
                      disabled={editBtnflag === true ? false : true}
                      autoComplete="off"
                    />
                  </InputGroup>
                  <ErrorLabel ErrorDisplay={err_Display.errInstagramURL} />
                  {/* // */}
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    LinkedIn URL
                  </Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Control
                      type="text"
                      value={
                        editFlag.editLinkedInURL === true
                          ? userInput.editLinkedInURL
                          : UserData.linkedin_url
                      }
                      placeholder="Paste your linkedIn URL here"
                      className="custom-formcontrol"
                      onChange={onLinkedInURL}
                      disabled={editBtnflag === true ? false : true}
                      autoComplete="off"
                    />
                  </InputGroup>
                  <ErrorLabel ErrorDisplay={err_Display.errLinkedInURL} />
                </Form.Group>
              </Col>
            </Row>
            {editBtnflag === true ? (
              <div className="text-center small-btns d-flex">
                <Link onClick={CancelHandler}>
                  <p className="view">Cancel</p>
                </Link>
                <Button
                  variant="primary"
                  type="submit"
                  className="green-btn mt-3"
                  onClick={(e) => SaveHandler(e)}
                >
                  Save
                </Button>
              </div>
            ) : (
              <></>
            )}
          </Form>
        </Col>
        <Col md="1" lg="2"></Col>
      </Row>
      <DeletePopUp
        show={deletemodalShow}
        onHide={() => setDeleteModalShow(false)}
      />
    </>
  );
};

export default MyProfileGeneralInfo;
